import { signOut } from "firebase/auth";

const LogoutFunction = (
  auth,
  redirect,
  setIfAccExists,
  setIsLogut,
  setUserExists
) => {
  setIfAccExists(false);

  setIsLogut(false);

  signOut(auth)
    .then(() => {
      setUserExists(false);

      setIsLogut(true);

      redirect("/ecomapp");
    })
    .catch((error) => {
      // An error happened.
      alert("Logout Failed Try Again");
    });
};

export default LogoutFunction;
